import React, { useEffect, useRef, useState } from "react";
import logo from "../assest/brand-logo.png";
import { useNavigate, useLocation, Link } from "react-router-dom";
import SuggestionModal from "./SuggestionModal";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";

const NavLink = ({
  href,
  icon,
  label,
  isOpen,
  isActive = false
}) => (
  <Link
    to={href}
    className={`flex items-center ${isOpen ? 'justify-start' : 'justify-center'} space-x-3 px-3 py-3 rounded-lg transition-all duration-200 group ${isActive
      ? 'bg-[#B03B82] text-white'
      : 'text-gray-700 hover:bg-purple-100 hover:text-[#B03B82]'
      }`}
  >
    <i className={`bx ${icon} text-xl flex-shrink-0`}></i>
    {isOpen && <span className="text-sm font-medium whitespace-nowrap">{label}</span>}
  </Link>
);

const NavButton = ({
  onClick,
  icon,
  label,
  isOpen,
  isSvg = false,
  isActive = false
}) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center ${isOpen ? 'justify-start' : 'justify-center'} space-x-3 px-3 py-3 rounded-lg transition-all duration-200 text-left group ${isActive
      ? 'bg-[#B03B82] text-white'
      : 'text-gray-700 hover:bg-purple-100 hover:text-[#B03B82]'
      }`}
  >
    {isSvg ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5 flex-shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 18h6" />
        <path d="M10 22h4" />
        <path d="M12 2v1" />
        <path d="M12 8a4 4 0 0 0-2 7.5V16h4v-.5A4 4 0 0 0 12 8Z" />
        <path d="M12 11v.01" />
        <path d="M12 14v.01" />
        <path d="M4.22 10.22l1.42 1.42" />
        <path d="M18.36 10.22l-1.42 1.42" />
        <path d="M5 16h.01" />
        <path d="M19 16h.01" />
        <path d="M5 12h.01" />
        <path d="M19 12h.01" />
        <path d="M4.22 17.78l1.42-1.42" />
        <path d="M18.36 17.78l-1.42-1.42" />
      </svg>
    ) : (
      <i className={`bx ${icon} text-xl flex-shrink-0`}></i>
    )}
    {isOpen && <span className="text-sm font-medium whitespace-normal break-words">{label}</span>}
  </button>
);

const Header = ({ dir }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try {
      const v = localStorage.getItem("sidebarOpen");
      return v ? v === "1" : false;
    } catch (e) {
      return false;
    }
  });
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 1024 : false);
  const [loading] = useState(false);
  const [isSuggestionModalOpen, setIsSuggestionModalOpen] = useState(false);
  const sidebarRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState(i18n.language === "ar" ? "العربية" : "English");
  const navigate = useNavigate();
  const location = useLocation();
  const [lmsOpen, setLmsOpen] = useState(location.pathname.startsWith('/lms'));
  const { t } = useTranslation();
  const storedData = localStorage.getItem("profileData") || sessionStorage.getItem("profileData");
  let parsedDataOutScope;

  if (storedData) {
    const parsedData = JSON.parse(storedData);
    parsedDataOutScope = parsedData;
  }

  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', sidebarOpen ? '256px' : '80px');
    document.documentElement.style.setProperty('--sidebar-open', sidebarOpen ? '1' : '0');
    try {
      localStorage.setItem('sidebarOpen', sidebarOpen ? '1' : '0');
    } catch (e) {
      // ignore
    }
  }, [sidebarOpen]);

  // Helper function to check if a route is active
  const isRouteActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const changeLanguage = (lang) => {
    let keylang = "";
    if (lang === "English") {
      keylang = "en";
    } else if (lang === "العربية") {
      keylang = "ar";
    }

    i18n.changeLanguage(keylang);
    setLanguage(lang);
    setOpen(false);

  };
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSignOut = () => {

    // Remove user data and token from localStorage
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("profileData");

    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("profileData");

    sessionStorage.removeItem("conversation");
    sessionStorage.removeItem("currentSessionId");
    sessionStorage.removeItem("sessionNumber");
    sessionStorage.removeItem("sessions");
    // Redirect to the login page
    navigate("/login");
  };

  const handleSettingsClick = () => {
    navigate("/update-password", { state: { startNew: true } });
  };

  const handleNewSessionClick = () => {
    // if (onStartNewSession) {
    //   onStartNewSession();
    // }
    navigate("/", { state: { startNew: true } });
    sessionStorage.removeItem("conversation");
    sessionStorage.removeItem("currentSessionId");
    sessionStorage.removeItem("sessionNumber");
    window.location.reload();
  };

  const handleSuggestionClick = (event) => {
    event.stopPropagation();
    setIsSuggestionModalOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isMyCoursesActive = isRouteActive("/lms/courses") || isRouteActive("/lms/courses") || (location.pathname.startsWith('/lms/course') && new URLSearchParams(location.search).has('module'));
  const isLmsActive = isRouteActive("/lms") || isRouteActive("/lms/dashboard") || isMyCoursesActive;
  const isContentViewActive = isRouteActive('/lms/dashboard/ContentView') || isRouteActive('/lms/all-courses')

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024; // treat small + tablet as mobile
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div dir={dir}>
      {/* Header */}
      <header className={`fixed top-0 ${dir === 'rtl' ? 'right-0' : 'left-0'} z-40 w-full transition-all duration-300 ease-in-out ${isMobile ? '' : (sidebarOpen ? (dir === 'rtl' ? 'pr-64' : 'pl-64') : (dir === 'rtl' ? 'pr-20' : 'pl-20'))
        } bg-white border-b border-gray-200 h-16`}>
        <div className="flex items-center justify-between h-full px-4">
          {/* Left side - Logo and Toggle */}
          <div className="flex items-center gap-3">
            {!sidebarOpen && <button
              onClick={toggleSidebar}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            >
              <i className={`bx bx-menu text-2xl text-gray-700 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`}></i>
            </button>}
            {!sidebarOpen && (
              <img
                src={logo}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleNewSessionClick();
                }}
                alt="Logo"
                className="w-40 h-auto cursor-pointer hover:opacity-80 transition-opacity hidden md:block"
              />
            )}
          </div>

          {/* Right side - Profile */}
          <div className="relative" ref={dropdownRef}>
            <div
              className="w-12 h-12 cursor-pointer bg-gray-100 object-cover rounded-full border-4 border-[#B03982] flex items-center justify-center hover:shadow-lg transition-shadow"
              onClick={() => setDropdownOpen((prev) => !prev)}
            >
              <span className="text-black text-[18px] font-semibold">
                {parsedDataOutScope?.name
                  ?.split(" ")
                  .map(word => word[0])
                  .slice(0, 2)
                  .join("")
                  .toUpperCase()
                }
              </span>
            </div>

            {/* Dropdown Menu */}
            {dropdownOpen && (
              <div className={`absolute ${dir === 'rtl' ? 'left-0' : 'right-0'} mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-200 z-50 overflow-hidden`}>
                <button
                  onClick={() => {
                    navigate("/profile", { state: { startNew: true } });
                    setDropdownOpen(false);
                  }}
                  className={`block w-full ${dir === 'rtl' ? 'text-right' : 'text-left'} px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 transition-colors`}
                >
                  {t("profile")}
                </button>
                <button
                  onClick={() => {
                    handleSignOut();
                    setDropdownOpen(false);
                  }}
                  className={`block w-full ${dir === 'rtl' ? 'text-right' : 'text-left'} px-4 py-3 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors border-t border-gray-200`}
                >
                  {t("logout")}
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Sidebar: desktop stays fixed; mobile uses overlay panel */}
      {isMobile ? (
        sidebarOpen && (
          <div className="fixed inset-0 z-[1000000000]">
            <div className="absolute inset-0 bg-black/40" onClick={toggleSidebar} />
            <aside
              ref={sidebarRef}
              id="nav-bar"
              className={`absolute top-0 ${dir === 'rtl' ? 'right-0' : 'left-0'} h-full w-64 bg-white border-r border-gray-200 shadow-lg pt-0 transform transition-transform duration-300 ease-in-out`}
              onClick={(e) => e.stopPropagation()}
            >
              <nav dir={dir} className="flex flex-col h-full px-2 py-4 space-y-2">
                {sidebarOpen && (
                  <div className="flex items-center justify-between mb-4 mt-1 px-2 relative">
                    <img src={logo} alt="Logo" className="w-40 h-auto cursor-pointer" onClick={handleNewSessionClick} />
                    <button className="absolute right-0 w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: '#F3F4F6' }} onClick={toggleSidebar}>
                      <i className={`bx bx-chevron-down text-2xl text-gray-400 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`} />
                    </button>
                  </div>
                )}
                <NavButton onClick={handleNewSessionClick} icon="bx-plus" label={t('start_new_session')} isOpen={sidebarOpen} isActive={isRouteActive('/')} />
                <NavLink href="/session-history" icon="bx-history" label={t('session_history')} isOpen={sidebarOpen} loading={loading} isActive={isRouteActive('/session-history')} />
                <NavLink href="/meeting-list" icon="bx-calendar" label={t('Recordings')} isOpen={sidebarOpen} loading={loading} isActive={isRouteActive('/meeting-list')} />
                <div>
                  <button
                    onClick={() => {
                      if (!sidebarOpen) {
                        navigate("/lms/courses");
                        setLmsOpen(true);
                      } else {
                        setLmsOpen((prev) => !prev);
                      }
                    }}
                    className={`w-full flex items-center ${sidebarOpen ? "space-x-3 px-3" : "justify-center"} py-3 rounded-lg transition-all duration-200 text-left group ${isLmsActive ? "bg-[#B03B82] text-white" : "text-gray-700 hover:bg-purple-100 hover:text-[#B03B82]"}`}>
                    <i className="bx bx-book text-xl flex-shrink-0"></i>
                    {sidebarOpen && <span className="text-sm font-medium">{t("LMS")}</span>}
                    {sidebarOpen && (
                      <i className={`bx ml-auto ${lmsOpen ? "bx-chevron-down" : "bx-chevron-right"}`} />
                    )}
                  </button>
                  {lmsOpen && sidebarOpen && (
                    <div className="pl-6 mt-1 space-y-1">
                      <NavLink href="/lms/dashboard" icon="bx-dashboard" label={t("dashboard")} isOpen={sidebarOpen} loading={loading} isActive={isRouteActive("/lms/dashboard") && !isContentViewActive} />
                      <NavLink href="/lms/courses" icon="bx-education" label={t("My Courses")} isOpen={sidebarOpen} loading={loading} isActive={isMyCoursesActive || isContentViewActive} />
                    </div>
                  )}
                </div>
                <NavButton onClick={handleSettingsClick} icon="bx-cog" label={t('settings')} isOpen={sidebarOpen} isActive={isRouteActive('/update-password')} />
                <NavButton onClick={handleSuggestionClick} icon="bx-lightbulb" label={t('suggestion_to_the_management')} isOpen={sidebarOpen} isSvg={true} />
                <div className="pt-4 border-t border-gray-200 mt-auto">
                  <button onClick={() => { setSidebarOpen(true); setOpen(!open); }} className={`flex items-center ${sidebarOpen ? 'justify-start' : 'justify-center'} w-full px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 text-gray-700`}>
                    <div className={`flex  items-center space-x-3`}>
                      <i className="bx bx-globe text-xl"></i>
                      {sidebarOpen && <span className="text-sm font-medium truncate">{language}</span>}
                    </div>
                    {sidebarOpen && <i className={`bx bx-chevron-down text-lg transition-transform ${open ? 'rotate-180' : ''}`}></i>}
                  </button>

                  {open && sidebarOpen && (
                    <div className="mt-2 space-y-1 rounded-lg bg-gray-50">
                      <button className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-200 rounded transition-colors" onClick={() => changeLanguage('English')}>English</button>
                      <button className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-200 rounded transition-colors" onClick={() => changeLanguage('العربية')}>Arabic</button>
                    </div>
                  )}
                </div>
              </nav>
            </aside>
          </div>
        )
      ) : (
        <div
          ref={sidebarRef}
          className={`fixed top-0 ${dir === 'rtl' ? 'right-0' : 'left-0'} z-[1000000000] h-screen transition-all duration-300 ease-in-out ${sidebarOpen ? 'w-64' : 'w-20'} bg-white border-r border-gray-200 shadow-lg pt-0`}
          id="nav-bar"
          onClick={(e) => e.stopPropagation()}
        >
          <nav dir={dir} className="flex flex-col h-full px-2 py-4 space-y-2">
            {sidebarOpen && (
              <div className="flex items-center justify-between mb-4 mt-1 px-2 relative">
                <img src={logo} alt="Logo" className="w-40 h-auto cursor-pointer" onClick={handleNewSessionClick} />
                <button className="absolute right-0 w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: '#F3F4F6' }} onClick={toggleSidebar}>
                  <i className={`bx bx-chevron-down text-2xl text-gray-400 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`} />
                </button>
              </div>
            )}
            <NavButton onClick={handleNewSessionClick} icon="bx-plus" label={t('start_new_session')} isOpen={sidebarOpen} isActive={isRouteActive('/')} />
            <NavLink href="/session-history" icon="bx-history" label={t('session_history')} isOpen={sidebarOpen} loading={loading} isActive={isRouteActive('/session-history')} />
            <NavLink href="/meeting-list" icon="bx-calendar" label={t('Recordings')} isOpen={sidebarOpen} loading={loading} isActive={isRouteActive('/meeting-list')} />
            <div>
              <button
                onClick={() => {
                  if (!sidebarOpen) {
                    navigate("/lms/courses");
                    setLmsOpen(true);
                  } else {
                    setLmsOpen((prev) => !prev);
                  }
                }}
                className={`w-full flex items-center ${sidebarOpen ? "space-x-3 px-3" : "justify-center"} py-3 rounded-lg transition-all duration-200 text-left group ${isLmsActive ? "bg-[#B03B82] text-white" : "text-gray-700 hover:bg-purple-100 hover:text-[#B03B82]"}`}>
                <i className="bx bx-book text-xl flex-shrink-0"></i>
                {sidebarOpen && <span className="text-sm font-medium">{t("LMS")}</span>}
                {sidebarOpen && (
                  <i className={`bx ml-auto ${lmsOpen ? "bx-chevron-down" : "bx-chevron-right"}`} />
                )}
              </button>
              {lmsOpen && sidebarOpen && (
                <div className="pl-6 mt-1 space-y-1">
                  <NavLink href="/lms/dashboard" icon="bx-dashboard" label={t("dashboard")} isOpen={sidebarOpen} loading={loading} isActive={isRouteActive("/lms/dashboard") && !isContentViewActive} />
                  <NavLink href="/lms/courses" icon="bx-education" label={t("My Courses")} isOpen={sidebarOpen} loading={loading} isActive={isMyCoursesActive || isContentViewActive} />
                </div>
              )}
            </div>
            {/* <NavButton onClick={handleSettingsClick} icon="bx-cog" label={t('settings')} isOpen={sidebarOpen} isActive={isRouteActive('/update-password')} /> */}
            <NavButton onClick={handleSuggestionClick} icon="bx-lightbulb" label={t('suggestion_to_the_management')} isOpen={sidebarOpen} isSvg={true} />
            <div className="pt-4 border-t border-gray-200 mt-auto">
              <button onClick={() => { setSidebarOpen(true); setOpen(!open); }} className={`flex items-center ${sidebarOpen ? 'justify-start' : 'justify-center'} w-full px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 text-gray-700`}>
                <div className={`flex  items-center space-x-3`}>
                  <i className="bx bx-globe text-xl"></i>
                  {sidebarOpen && <span className="text-sm font-medium truncate">{language}</span>}
                </div>
                {sidebarOpen && <i className={`bx bx-chevron-down text-lg transition-transform ${open ? 'rotate-180' : ''}`}></i>}
              </button>

              {open && sidebarOpen && (
                <div className="mt-2 space-y-1 rounded-lg bg-gray-50">
                  <button className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-200 rounded transition-colors" onClick={() => changeLanguage('English')}>English</button>
                  <button className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-200 rounded transition-colors" onClick={() => changeLanguage('العربية')}>Arabic</button>
                </div>
              )}
            </div>
          </nav>
        </div>
      )}

      {/* Main content wrapper - shifts when sidebar opens */}
      <div className={`transition-all duration-300 ease-in-out ${isMobile ? (dir === 'rtl' ? 'mr-0' : 'ml-0') : (sidebarOpen ? (dir === 'rtl' ? 'mr-64' : 'ml-64') : (dir === 'rtl' ? 'mr-20' : 'ml-20'))}`}>
        {/* Content goes here */}
      </div>

      {/* Suggestion Modal */}
      <SuggestionModal
        isOpen={isSuggestionModalOpen}
        onClose={() => setIsSuggestionModalOpen(false)}
        dir={dir}
      />
    </div>
  );

};

export default Header;